;(function () {
    var mapElements = document.querySelectorAll('.ce_google_maps');
    if (!mapElements.length) {
        return;
    }

    function loadJS(u) {
        var r = document.getElementsByTagName("script")[0], s = document.createElement("script");
        s.src = u;
        r.parentNode.insertBefore(s, r);
    }

    loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBc9oU-bjBKzfT9q7HskE4tbJZHJljZJ74');

    function waitForGoogleMapsScript() {
        if (window.google && google.maps) {
            onGoogleMapScriptLoaded();
        } else {
            setTimeout(waitForGoogleMapsScript, 300);
        }
    }

    waitForGoogleMapsScript();

    function onGoogleMapScriptLoaded() {
        Array.from(mapElements).forEach(function (mapElement) {
            var styledMap = [
                {
                    stylers: [
                        {hue: '#472B0F'},
                        {saturation: -60},
                        {gamma: 1.2}
                    ]
                }
            ];

            var myLatlng = new google.maps.LatLng(48.205048, 16.369190);

            var mapOptions = {
                center: myLatlng,
                zoom: 16,
                styles: styledMap,

                // don't zoom on scrolling
                zoomControl: true,
                scrollwheel: false
            };

            var map = new google.maps.Map(mapElement, mapOptions);

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                clickable: false,
                title: 'The Guest House Vienna',
                icon: '/_Resources/Static/Packages/CodeQ.Site/Frontend/images/maps-marker.png'
            });
        });
    }
})();
